import { useCallback, useState } from 'react';
import { Message, UserMessage } from 'src/types';
import ContinueButton from './ContinueButton/ContinueButton';
import Footer from './Footer/Footer';
import Messages from './Messages/Messages';

import './Chat.sass';

interface ChatProps {
	messages?: Message[];
	blocked?: boolean;
	handleBlocked?: (s: boolean) => void;
}

const Chat = ({ messages, blocked, handleBlocked }: ChatProps) => {
	const [editing, setEditing] = useState<UserMessage | null>(null);

	const [streamingText, setStreamingText] = useState<string>('');

	const handleChunkReceived = useCallback((chunk: string) => {
		setStreamingText((prevText) => prevText + chunk);
	}, []);

	const handleStreamCompleted = useCallback(() => {
		setStreamingText('');
	}, []);

	const handleEditMode = {
		enable: (message: Message) => {
			if (message.from === 'user') {
				setEditing(message as UserMessage);
			}
		},
		disable: () => setEditing(null)
	};

	const disableCallback = useCallback(() => setEditing(null), []);

	return (
		<div id="chat">
			<Messages
				onChunk={handleChunkReceived}
				onComplete={handleStreamCompleted}
				handleEdit={handleEditMode}
				editing={editing}
				initialMessages={messages}
				streamingText={streamingText}
			/>
			{blocked && handleBlocked ? (
				<ContinueButton handleBlocked={handleBlocked} />
			) : (
				<Footer editing={editing} disableEditing={disableCallback} onChunk={handleChunkReceived} onComplete={handleStreamCompleted} />
			)}
		</div>
	);
};

export default Chat;
